module.exports = __webpack_public_path__ + "img/zahajenie-vystavby.05c7392b.svg";